/**
 * Same-tab bus for "the system-alert set changed". AdminLayout re-dispatches the
 * server's `alerts:changed` socket event on it, and the System Alerts page fires
 * it after acknowledge/resolve — so the sidebar badge, the page's stat cards and
 * its list all re-sync from one signal instead of each holding stale state.
 */
export const ALERTS_CHANGED_EVENT = 'baatly:alerts-changed';

/** When THIS tab last acted on an alert. The server echoes every change back over the socket
 *  (so other sessions update); without this the acting tab refetched everything twice. */
let lastLocalActionAt = 0;
const SERVER_ECHO_WINDOW_MS = 3000;

/** Call at the START of an acknowledge/resolve so the server's echo of it can be recognised. */
export function markLocalAlertsAction(): void {
  lastLocalActionAt = Date.now();
}

export function notifyAlertsChanged(): void {
  window.dispatchEvent(new Event(ALERTS_CHANGED_EVENT));
}

/** Socket-driven variant: skipped when it is just the echo of an action this tab already handled. */
export function notifyAlertsChangedFromServer(): void {
  if (Date.now() - lastLocalActionAt < SERVER_ECHO_WINDOW_MS) return;
  window.dispatchEvent(new Event(ALERTS_CHANGED_EVENT));
}
